import React from 'react';
import { PropTypes } from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import styles from './../../../components/App/styles';
import Login from './../Users/Login';

class LoginDedicated extends React.Component {
  render() {
    const { classes } = this.props;
    return (
      <div className={classes.appFrameOuter}>
        <main className={classes.outerContent} id="mainContent">
          <Login />
        </main>
      </div>
    );
  }
}

LoginDedicated.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default (withStyles(styles)(LoginDedicated));
